import { Plan } from './AccountModel';

export class IntegrationPartner {
  public id?: number;
  public name?: string;
  public partnerKey?: string;
  public planId?: number;
  public plan?: Plan;
  public applicationUrl?: string;

  constructor(obj: any = {} as IntegrationPartner) {
    this.id = obj.id;
    this.name = obj.name;
    this.partnerKey = obj.partnerKey;
    this.planId = obj.planId;
    this.plan = obj.plan;
    this.applicationUrl = obj.applicationUrl;
  }
}

export class ManageIntegrationModel {
  public id?: number;
  public accountId?: number;
  public isEnabled?: boolean;
  public companyRecId?: number;
  public companyId?: string;
  public companySite?: string;
  public manageCompanyName?: string;
  public apiPublicKey?: any;
  public apiPrivateKey?: any;

  constructor(obj: any = {} as ManageIntegrationModel) {
    this.id = obj.id;
    this.accountId = obj.accountId;
    this.isEnabled = obj.isEnabled;
    this.companyRecId = obj.companyRecId;
    this.companyId = obj.companyId;
    this.companySite = obj.companySite;
    this.manageCompanyName = obj.manageCompanyName;
    this.apiPublicKey = obj.apiPublicKey;
    this.apiPrivateKey = obj.apiPrivateKey;
  }
}